import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timestamp"]

  connect() {
    // create formatters once
    this.setupFormatters()

    // format any existing targets
    for (const el of this.timestampTargets) this.formatContainer(el)

    // observe subtree for newly inserted timestamp elements
    this._observer = new MutationObserver(mutations => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue
          if (node.matches('[data-timezone-target="timestamp"]')) {
            this.formatContainer(node)
          } else {
            node.querySelectorAll && node.querySelectorAll('[data-timezone-target="timestamp"]').forEach(el => this.formatContainer(el))
          }
        }
      }
    })
    this._observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    if (this._observer) this._observer.disconnect()
  }

  setupFormatters() {
    try {
      this.userTz = Intl.DateTimeFormat().resolvedOptions().timeZone
    } catch {
      this.userTz = undefined
    }
    const tzOption = this.userTz ? { timeZone: this.userTz } : {}
    this.dateFormatter = new Intl.DateTimeFormat(undefined, { dateStyle: "medium", ...tzOption })
    this.timeFormatter = new Intl.DateTimeFormat(undefined, { timeStyle: "short", ...tzOption })
  }

  formatContainer(container) {
    if (!container || container.dataset.__formatted === "1") return
    const ts = container.dataset.timestamp
    if (!ts) return

    const dt = new Date(ts)
    try {
      const dateStr = this.dateFormatter.format(dt)
      const timeStr = this.timeFormatter.format(dt)
      
      const dateEl = container.querySelector('[data-tz-role="date"]')
      if (dateEl) dateEl.textContent = dateStr
      
      const timeEl = container.querySelector('[data-tz-role="time"]')
      if (timeEl) timeEl.textContent = timeStr

      const smartEl = container.querySelector('[data-tz-role="smart"]')
      if (smartEl) {
        const now = new Date()
        const isToday = dt.toLocaleDateString() === now.toLocaleDateString()
        if (isToday) {
          smartEl.textContent = timeStr
        } else {
          const mm = String(dt.getMonth() + 1).padStart(2, '0')
          const dd = String(dt.getDate()).padStart(2, '0')
          const yy = String(dt.getFullYear()).slice(-2)
          smartEl.textContent = `${mm}/${dd}/${yy}`
        }
      }

      container.title = dt.toLocaleString()
      container.dataset.__formatted = "1"
    } catch (e) {

      const dateEl = container.querySelector('[data-tz-role="date"]')
      if (dateEl) dateEl.textContent = dt ? dt.toLocaleDateString() : ""
      
      const timeEl = container.querySelector('[data-tz-role="time"]')
      if (timeEl) timeEl.textContent = dt ? dt.toLocaleTimeString() : ""

      const smartEl = container.querySelector('[data-tz-role="smart"]')
      if (smartEl && dt) {
        const now = new Date()
        const isToday = dt.toLocaleDateString() === now.toLocaleDateString()
        if (isToday) {
          smartEl.textContent = dt.toLocaleTimeString()
        } else {
          const mm = String(dt.getMonth() + 1).padStart(2, '0')
          const dd = String(dt.getDate()).padStart(2, '0')
          const yy = String(dt.getFullYear()).slice(-2)
          smartEl.textContent = `${mm}/${dd}/${yy}`
        }
      }

      container.dataset.__formatted = "1"
    }
  }
}